export const SAVE_USER = 'SAVE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const SAVE_USER_BOOKINGS = 'SAVE_USER_BOOKINGS';
export const SAVE_USER_PURCHASES = 'SAVE_USER_PURCHASES';
export const REMOVE_USER_BOOKINGS = 'REMOVE_USER_BOOKINGS';
export const REMOVE_USER_PURCHASES = 'REMOVE_USER_PURCHASES';
export const PROFILE_UPDATE = 'PROFILE_UPDATE';
export const SAVE_ORDER_BOOKING = 'SAVE_ORDER_BOOKING';
export const REMOVE_ORDER_BOOKING = 'REMOVE_ORDER_BOOKING';
